const TK_PLANNER_IOS_USER_AGENT = 'TKPlanner-iOS';
const TK_PLANNER_ANDROID_USER_AGENT = 'XOXO/PlannerApp';

const isMobileApp = userAgent =>
  typeof userAgent === 'string' &&
  [TK_PLANNER_IOS_USER_AGENT, TK_PLANNER_ANDROID_USER_AGENT].some(marker =>
    userAgent.includes(marker),
  );

export default isMobileApp;
